import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Notification } from "../Notification";
import { notificationListStyle } from "./notificationListStyle";
export const NotificationListLoading = () => (_jsxs("div", { className: notificationListStyle, children: [_jsx(Notification.Skeleton, {}), _jsx(Notification.Skeleton, {}), _jsx(Notification.Skeleton, {}), _jsx(Notification.Skeleton, {})] }));
//# sourceMappingURL=NotificationListLoading.js.map